import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export default function LandingPage() {
  const [formVisible, setFormVisible] = useState(false);
  const [form, setForm] = useState({ company_name: '', org_nr: '', contact_name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true); setError('');
    try {
      const res = await fetch(`${API_URL}/superadmin/applications`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSuccess(true);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '12px 14px', border: '1.5px solid #e2e8f0', borderRadius: 10, fontSize: 15, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, color: '#94a3b8', marginBottom: 6 };

  const features = [
    { icon: '✦', title: 'AI-genererad offerttext', desc: 'Skriv mötesanteckningar och låt AI formulera professionell offerttext på sekunder.' },
    { icon: '📄', title: 'Snygga PDF-offerter', desc: 'Exportera väldesignade PDF-filer med ert logotype och kontaktuppgifter.' },
    { icon: '✉️', title: 'Digital kundportal', desc: 'Kunden loggar in med sin e-post och accepterar eller avböjer direkt online.' },
    { icon: '🏠', title: 'ROT-avdrag', desc: 'Automatisk beräkning av ROT-avdrag med korrekt totalbelopp visas för kunden.' },
    { icon: '👥', title: 'Teamhantering', desc: 'Bjud in kollegor. Alla ser och hanterar offerter i ett gemensamt arbetsflöde.' },
    { icon: '🔔', title: 'Realtidsnotiser', desc: 'Få ett mail direkt när en kund accepterar eller avböjer din offert.' },
  ];

  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif", background: '#fafafa', color: '#0f172a', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;900&family=Lora:ital,wght@0,400;0,700;1,400&display=swap');
        * { box-sizing: border-box; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
        @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
        .fu1{animation:fadeUp .6s ease forwards;}
        .fu2{animation:fadeUp .6s .12s ease forwards;opacity:0;}
        .fu3{animation:fadeUp .6s .24s ease forwards;opacity:0;}
        .fu4{animation:fadeUp .6s .36s ease forwards;opacity:0;}
        .modal-bg{animation:fadeIn .25s ease;}
        .modal-box{animation:fadeUp .3s ease;}
        .feat:hover{transform:translateY(-3px);box-shadow:0 12px 36px rgba(0,0,0,0.08);}
        .feat{transition:all .2s;}
        .cta:hover{background:#1d4ed8!important;}
        .cta{transition:background .2s!important;}
      `}</style>

      {/* Nav */}
      <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:100, height:60, padding:'0 28px', display:'flex', alignItems:'center', justifyContent:'space-between', background: scrolled ? 'rgba(250,250,250,0.92)' : 'transparent', backdropFilter: scrolled ? 'blur(12px)' : 'none', borderBottom: scrolled ? '1px solid #f1f5f9' : 'none', transition:'all .3s' }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:28, height:28, background:'#2563eb', borderRadius:7, display:'grid', placeItems:'center' }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <span style={{ fontFamily:"'Lora',serif", fontSize:19, fontWeight:700, letterSpacing:'-0.5px' }}>iOffer</span>
        </div>
        <button onClick={() => window.location.href='/login'} style={{ background:'transparent', border:'1.5px solid #e2e8f0', borderRadius:9, padding:'7px 16px', fontSize:13, fontWeight:700, cursor:'pointer', color:'#475569', transition:'all .2s' }}
          onMouseOver={e=>{e.target.style.borderColor='#2563eb';e.target.style.color='#2563eb';}}
          onMouseOut={e=>{e.target.style.borderColor='#e2e8f0';e.target.style.color='#475569';}}>
          Logga in →
        </button>
      </nav>

      {/* Hero */}
      <section style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:'100px 24px 60px', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse 90% 60% at 50% 0%, rgba(37,99,235,0.06) 0%, transparent 65%)', pointerEvents:'none' }} />
        <div style={{ maxWidth:680, textAlign:'center', position:'relative' }}>
          <div className="fu1" style={{ display:'inline-flex', alignItems:'center', gap:7, background:'#eff6ff', border:'1px solid #bfdbfe', borderRadius:100, padding:'5px 14px', marginBottom:28, fontSize:13, fontWeight:600, color:'#2563eb' }}>
            <span style={{ width:6, height:6, background:'#2563eb', borderRadius:'50%', display:'inline-block' }}/>
            Offerthantering för moderna företag
          </div>
          <h1 className="fu2" style={{ fontFamily:"'Lora',serif", fontSize:'clamp(40px,7vw,70px)', lineHeight:1.1, letterSpacing:'-2px', marginBottom:22 }}>
            Skicka offerter som<br/><em style={{ color:'#2563eb' }}>imponerar</em>
          </h1>
          <p className="fu3" style={{ fontSize:'clamp(15px,2vw,18px)', color:'#64748b', lineHeight:1.7, maxWidth:500, margin:'0 auto 40px' }}>
            Skapa, skicka och hantera professionella offerter — med AI-stöd, kundportal och digital bekräftelse.
          </p>
          <div className="fu4" style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
            <button className="cta" onClick={()=>setFormVisible(true)} style={{ background:'#2563eb', color:'white', border:'none', borderRadius:12, padding:'14px 32px', fontSize:16, fontWeight:700, cursor:'pointer', boxShadow:'0 6px 24px rgba(37,99,235,0.28)' }}>
              Ansök om konto →
            </button>
            <button onClick={()=>document.getElementById('how').scrollIntoView({behavior:'smooth'})} style={{ background:'white', color:'#374151', border:'1.5px solid #e2e8f0', borderRadius:12, padding:'14px 22px', fontSize:15, fontWeight:600, cursor:'pointer' }}>
              Läs mer
            </button>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding:'70px 24px', maxWidth:1060, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:52 }}>
          <h2 style={{ fontFamily:"'Lora',serif", fontSize:'clamp(26px,4vw,42px)', letterSpacing:'-1px', marginBottom:12 }}>Allt du behöver</h2>
          <p style={{ fontSize:17, color:'#64748b' }}>Från anteckning till signerad affär — på några minuter.</p>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))', gap:18 }}>
          {features.map((f,i)=>(
            <div key={i} className="feat" style={{ background:'white', borderRadius:18, padding:'26px 22px', border:'1px solid #f1f5f9', boxShadow:'0 2px 10px rgba(0,0,0,0.04)' }}>
              <div style={{ fontSize:24, marginBottom:12 }}>{f.icon}</div>
              <h3 style={{ fontSize:16, fontWeight:700, marginBottom:7 }}>{f.title}</h3>
              <p style={{ fontSize:14, color:'#64748b', lineHeight:1.6 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Hur det fungerar */}
      <section id="how" style={{ padding:'70px 24px', background:'white', borderTop:'1px solid #f1f5f9', borderBottom:'1px solid #f1f5f9' }}>
        <div style={{ maxWidth:700, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom:48 }}>
            <h2 style={{ fontFamily:"'Lora',serif", fontSize:'clamp(24px,4vw,40px)', letterSpacing:'-1px', marginBottom:10 }}>Så enkelt fungerar det</h2>
          </div>
          {[
            { n:'01', t:'Skriv mötesanteckningar', d:'Fyll i vad ni diskuterade. AI hjälper dig formulera professionell offerttext.' },
            { n:'02', t:'Bygg offerten', d:'Lägg till tjänster, priser och ROT-avdrag om det gäller.' },
            { n:'03', t:'Skicka till kunden', d:'Kunden får ett mail med länk till sin personliga offertportal.' },
            { n:'04', t:'Affären är klar', d:'Kunden accepterar digitalt och du får ett notismail direkt.' },
          ].map((s,i)=>(
            <div key={i} style={{ display:'flex', gap:18, padding:'22px 0', borderBottom: i<3 ? '1px solid #f8fafc' : 'none', alignItems:'flex-start' }}>
              <div style={{ width:42, height:42, background:'#eff6ff', borderRadius:12, display:'grid', placeItems:'center', flexShrink:0 }}>
                <span style={{ fontSize:11, fontWeight:900, color:'#2563eb' }}>{s.n}</span>
              </div>
              <div>
                <h3 style={{ fontSize:16, fontWeight:700, marginBottom:5 }}>{s.t}</h3>
                <p style={{ fontSize:14, color:'#64748b', lineHeight:1.6 }}>{s.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{ padding:'80px 24px', textAlign:'center', background:'#0f172a', color:'white' }}>
        <h2 style={{ fontFamily:"'Lora',serif", fontSize:'clamp(26px,4vw,48px)', letterSpacing:'-1.5px', marginBottom:14 }}>Redo att komma igång?</h2>
        <p style={{ fontSize:16, color:'#94a3b8', marginBottom:32 }}>Ansök om konto – vi hör av oss inom kort.</p>
        <button className="cta" onClick={()=>setFormVisible(true)} style={{ background:'#2563eb', color:'white', border:'none', borderRadius:12, padding:'15px 34px', fontSize:16, fontWeight:700, cursor:'pointer', boxShadow:'0 8px 28px rgba(37,99,235,0.35)' }}>
          Ansök om konto →
        </button>
      </section>

      {/* Footer */}
      <footer style={{ padding:'24px 28px', borderTop:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10, background:'white' }}>
        <span style={{ fontFamily:"'Lora',serif", fontSize:15, fontWeight:700 }}>iOffer</span>
        <p style={{ fontSize:12, color:'#94a3b8' }}>© {new Date().getFullYear()} iOffer – Offerthantering för moderna företag</p>
        <button onClick={()=>window.location.href='/login'} style={{ background:'none', border:'none', fontSize:13, color:'#2563eb', cursor:'pointer', fontWeight:700 }}>Logga in →</button>
      </footer>

      {/* Ansökningsmodal */}
      {formVisible && (
        <div className="modal-bg" onClick={e=>{if(e.target===e.currentTarget){setFormVisible(false);setSuccess(false);setError('');}}} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', backdropFilter:'blur(6px)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, zIndex:200 }}>
          <div className="modal-box" style={{ background:'white', borderRadius:22, padding:36, width:'100%', maxWidth:500, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 24px 80px rgba(0,0,0,0.2)' }}>
            {success ? (
              <div style={{ textAlign:'center', padding:'12px 0' }}>
                <div style={{ fontSize:52, marginBottom:16 }}>🎉</div>
                <h2 style={{ fontFamily:"'Lora',serif", fontSize:24, marginBottom:12 }}>Ansökan skickad!</h2>
                <p style={{ color:'#64748b', lineHeight:1.65, marginBottom:28 }}>Vi har tagit emot din ansökan och skickat en bekräftelse till din e-post. Vi hör av oss inom kort!</p>
                <button onClick={()=>{setFormVisible(false);setSuccess(false);}} style={{ background:'#2563eb', color:'white', border:'none', borderRadius:10, padding:'12px 28px', fontSize:15, fontWeight:700, cursor:'pointer' }}>Stäng</button>
              </div>
            ) : (
              <>
                <h2 style={{ fontFamily:"'Lora',serif", fontSize:24, marginBottom:6 }}>Ansök om konto</h2>
                <p style={{ color:'#64748b', fontSize:14, marginBottom:24 }}>Fyll i formuläret så hör vi av oss inom kort.</p>
                <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:13 }}>
                  {[
                    { label:'Företagsnamn *', name:'company_name', placeholder:'Ditt Företag AB', required:true },
                    { label:'Org.nr', name:'org_nr', placeholder:'556677-8899' },
                    { label:'Kontaktperson *', name:'contact_name', placeholder:'Anna Svensson', required:true },
                    { label:'E-post *', name:'email', type:'email', placeholder:'anna@foretaget.se', required:true },
                    { label:'Telefon', name:'phone', placeholder:'070-123 45 67' },
                  ].map(f=>(
                    <div key={f.name}>
                      <label style={labelStyle}>{f.label}</label>
                      <input type={f.type||'text'} required={f.required} placeholder={f.placeholder}
                        value={form[f.name]} onChange={e=>setForm(p=>({...p,[f.name]:e.target.value}))}
                        style={inputStyle}
                        onFocus={e=>e.target.style.borderColor='#2563eb'}
                        onBlur={e=>e.target.style.borderColor='#e2e8f0'} />
                    </div>
                  ))}
                  <div>
                    <label style={labelStyle}>Meddelande</label>
                    <textarea placeholder="Berätta gärna kort om er verksamhet..."
                      value={form.message} onChange={e=>setForm(p=>({...p,message:e.target.value}))}
                      rows={3} style={{...inputStyle, resize:'vertical'}}
                      onFocus={e=>e.target.style.borderColor='#2563eb'}
                      onBlur={e=>e.target.style.borderColor='#e2e8f0'} />
                  </div>
                  {error && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:10, padding:'11px 14px', color:'#dc2626', fontSize:14 }}>{error}</div>}
                  <div style={{ display:'flex', gap:10, marginTop:6 }}>
                    <button type="button" onClick={()=>setFormVisible(false)} style={{ flex:1, background:'#f1f5f9', border:'none', borderRadius:10, padding:'13px', fontSize:15, fontWeight:600, cursor:'pointer', color:'#475569' }}>Avbryt</button>
                    <button type="submit" disabled={loading} style={{ flex:2, background:loading?'#93c5fd':'#2563eb', color:'white', border:'none', borderRadius:10, padding:'13px', fontSize:15, fontWeight:700, cursor:loading?'wait':'pointer' }}>
                      {loading ? 'Skickar...' : 'Skicka ansökan →'}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
